import styled from 'styled-components';

import { Box } from '../../../styles/GlobalComponents';

export const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const IconBitcoinPlus = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M24.6209 11.9825C24.6209 18.3996 19.1476 23.6018 12.3969 23.6018C5.64619 23.6018 0.171875 18.4005 0.171875 11.9825C0.171875 5.56458 5.64523 0.363281 12.3959 0.363281C19.1466 0.363281 24.62 5.56549 24.62 11.9825H24.6209ZM22.7245 11.9835C22.7245 6.56119 18.1005 2.16646 12.3959 2.16646C6.69137 2.16646 2.0683 6.56119 2.0683 11.9835C2.0683 17.4057 6.69233 21.8005 12.3969 21.8005C18.1014 21.8005 22.7255 17.4048 22.7255 11.9835H22.7245Z'
      fill='#EDD999'
    />
    <path
      d='M13.3522 10.9848H17.1498C17.275 10.9848 17.5903 11.1093 17.7001 11.1875C18.2409 11.5758 18.1979 12.3715 17.6008 12.6843C17.5549 12.7088 17.3667 12.8007 17.3409 12.8007H13.3522V16.5471C13.3522 16.5625 13.249 16.7989 13.228 16.838C12.8879 17.4546 11.9058 17.4546 11.5656 16.838C11.5446 16.7998 11.4415 16.5634 11.4415 16.5471V12.8007H7.45275C7.42695 12.8007 7.23875 12.7088 7.19289 12.6843C6.59578 12.3715 6.55278 11.5758 7.09353 11.1875C7.2034 11.1084 7.51963 10.9848 7.64383 10.9848H11.4415V7.28383C11.4415 7.23837 11.5551 6.98467 11.5924 6.92829C11.9631 6.35724 12.8306 6.35724 13.2013 6.92829C13.2385 6.98558 13.3522 7.23837 13.3522 7.28383V10.9848Z'
      fill='#EDD999'
    />
  </svg>
);

export const IconBitcoinMinus = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M24.4491 11.983C24.4491 18.4008 18.9762 23.6027 12.2245 23.6027C5.47287 23.6027 0 18.4008 0 11.983C0 5.56519 5.47287 0.363281 12.2245 0.363281C18.9762 0.363281 24.4491 5.5661 24.4491 11.983ZM22.5534 11.983C22.5534 6.56101 17.9289 2.16576 12.2245 2.16576C6.5202 2.16576 1.89666 6.56101 1.89666 11.983C1.89666 17.405 6.52115 21.8002 12.2255 21.8002C17.9298 21.8002 22.5543 17.405 22.5543 11.983H22.5534Z'
      fill='#EDD999'
    />
    <path
      d='M7.48627 10.9962L16.8825 10.9844C18.1164 11.0253 18.3 12.5695 17.0748 12.7996H7.37723C6.20174 12.5941 6.30695 11.089 7.48627 10.9962Z'
      fill='#EDD999'
    />
  </svg>
);
